<template>
  <v-container fluid>
    <v-layout wrap row v-if="!!getTableau.length" class="px-3 flex-column">
      <div class="my-3 scan-header">SITE REPORTS</div>
      <v-radio-group v-model="selected" row>
        <v-radio
          :name="item.type"
          v-for="item in getTableau"
          :key="item.url"
          :label="item.type"
          :value="item"
          color="success"
        />
      </v-radio-group>
      <iframe :src="selected.url" frameborder="0" scrolling="no" />
    </v-layout>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from "vuex";
  import asyncDataStatus from "../mixins/asyncDataStatus";
  const authHelper = createNamespacedHelpers("auth");

  export default {
    name: "SiteReports",
    mixins: [asyncDataStatus],
    data() {
      return {
        selected: {}
      };
    },
    computed: {
      ...authHelper.mapGetters(["getSelectedClient", "getTableau"])
    },
    methods: {
      ...authHelper.mapActions(["fetchClientsList", "fetchClientTableau"]),
      async loadTableau() {
        try {
          await this.loadingStart();

          const tableau = await this.fetchClientTableau(this.getSelectedClient);
          this.selected = tableau[0];

          //To call error in catch sentence
        } catch (e) {
          window.alert(e);

          // window.alert("pls, check the type or the tableau url on this data");
        } finally {
          await this.loadingEnd();
        }
      }
    },
    watch: {
      getSelectedClient: function() {
        this.loadTableau();
      }
    },
    created() {
      this.loadTableau();
    }
  };
</script>
<style lang="scss">
  iframe {
    /* margin: 40px 0; */
    width: 100%;
    min-height: 1000px;

    /* overflow: hidden; */
  }
</style>
